import { render, staticRenderFns } from "./blocks.vue?vue&type=template&id=a54a2d7c&scoped=true"
import script from "./blocks.vue?vue&type=script&lang=js"
export * from "./blocks.vue?vue&type=script&lang=js"
import style0 from "./blocks.vue?vue&type=style&index=0&id=a54a2d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54a2d7c",
  null
  
)

export default component.exports